var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agePie-control"},[_c('div',{staticClass:"agePie-title"},[_vm._v("年龄分布")]),_c('div',{staticClass:"agePie-con"},[_c('chartsPie',{key:_vm.timer,attrs:{"option":_vm.chartsAgeData,"id":"chartsAgePie"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }